import { jsonApi } from '../jsonApi';
import { model } from './web-container';

// Warning : this model is duplicated from web-container.js
// You need to change the model in web-ctainer.js to change this model
jsonApi.define('tms/container', model);
